import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { CatalogueIdsProps } from './types';
import ProductCatalogue from './ProductCatalogue';
import useMediaQuery from 'hooks/useMediaQuery';
import React, { useEffect, useRef, useState } from 'react';

const ProductsRecommendation = ({
  catalogueIds,
}: CatalogueIdsProps) => {
  const tabListRef = useRef<HTMLDivElement>(null);

  const isMobileViewport = useMediaQuery('(max-width: 480px)');
  const isPointerCoarse = useMediaQuery('(pointer: coarse)');

  const [isLeftButtonVisible, setIsLeftButtonVisible] = useState(
    false,
  );
  const [isRightButtonVisible, setIsRightButtonVisible] = useState(
    false,
  );
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(
      Boolean(isMobileViewport) && Boolean(isPointerCoarse),
    );
  }, [isMobileViewport, isPointerCoarse]);

  useEffect(() => {
    const tabListEl = tabListRef.current;
    if (!tabListEl) return;

    const handleScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = tabListEl;

      setIsLeftButtonVisible(scrollLeft > 0);
      setIsRightButtonVisible(
        scrollLeft + clientWidth < scrollWidth - 5,
      );
    };

    tabListEl.addEventListener('scroll', handleScroll);

    const timeout = setTimeout(() => {
      handleScroll();
    }, 0);

    return () => {
      tabListEl.removeEventListener('scroll', handleScroll);
      clearTimeout(timeout);
    };
  }, [isRightButtonVisible, isLeftButtonVisible]);

  const handleArrowClicked = (amount: number) => {
    if (tabListRef.current) {
      tabListRef.current.scrollTo({
        left: tabListRef.current.scrollLeft + amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Tabs defaultIndex={0} selectedTabClassName="show">
      <div className="tw-relative">
        <React.Fragment>
          {isMobile && isLeftButtonVisible ? (
            <div
              className="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-items-center tw-cursor-pointer tw-w-12 tw-h-12 tw-justify-center tw-rounded-full tw-bg-gray-200/80 tw-flex"
              onClick={() => handleArrowClicked(-150)}
            >
              <i className="fas fa-chevron-left"></i>
            </div>
          ) : null}
          {isMobile && isRightButtonVisible ? (
            <div
              className="tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-items-center tw-cursor-pointer tw-w-12 tw-h-12 tw-justify-center tw-rounded-full tw-bg-gray-200/80 tw-flex"
              onClick={() => handleArrowClicked(150)}
            >
              <i className="fas fa-chevron-right"></i>
            </div>
          ) : null}
        </React.Fragment>
        <div
          className="tw-flex tw-w-full no-scrollbar tw-overflow-auto"
          ref={tabListRef}
        >
          <TabList
            className={`nav nav-pills ${
              isMobile
                ? 'tw-flex-nowrap'
                : 'tw-justify-center tw-flex-wrap'
            }`}
            role="tablist"
          >
            {catalogueIds.map((catalogue) => (
              <Tab
                className={`nav-item ${
                  isMobile &&
                  'tw-flex tw-whitespace-nowrap tw-m-0 tw-gap-4'
                }`}
              >
                <span className="nav-link">
                  {`${catalogue.key} kcal per meal`}
                </span>
              </Tab>
            ))}
          </TabList>
        </div>
      </div>
      <div className="tab-pane tab-content">
        {catalogueIds.map((catalogue) => (
          <TabPanel key={catalogue.value}>
            <ProductCatalogue catalogueId={catalogue.value} />
          </TabPanel>
        ))}
      </div>
    </Tabs>
  );
};

export default ProductsRecommendation;
